var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGungoren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "katman_1",
    "data-name": "katman 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,10.9c-.8,2.9-.7,6.4-3.8,8.5-.7.5-1.5,1.4-1.5,2.1.5,5.5-4,5.4-7.2,6.5-4.5,1.6-8.4,2-11.6-3-2.4-3.6-6.3-6.2-9.4-9.3-.7-.7-1.8-1.3-1.2-2.6.4-1,1.5-.8,2.4-.9,8.7-.7,17.2-2.7,25.2-6.1,3.3-1.4,7.4,1.3,7.3,4.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGungoren);
export default __webpack_public_path__ + "static/media/gungoren.cd890911092a4ef56c49ac16fb303d55.svg";
export { ForwardRef as ReactComponent };